import { MatSnackBar } from "@angular/material/snack-bar";

export function compareJSONValues(json1: Record<string, any>, json2: Record<string, any>) {
    const differences: { key: string, value1: any, value2: any }[] = [];

    // Loop through all keys in json1
    for (const key in json1) {
        if (json1.hasOwnProperty(key) && json2.hasOwnProperty(key)) {
            const value1 = json1[key];
            const value2 = json2[key];

            // Compare types of the values
            if (value1 !== value2) {
                differences.push({ key, value1, value2 });
            }
        }



    }

    return differences;
}


export function openSnackBar(message: string, duration: number, snackBar: MatSnackBar) {
    snackBar.open(message, "Dismiss", { duration: duration })
  }


